"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var React = __importStar(require("react"));
var App_1 = require("../../App");
var constants_1 = require("../../Common/utils/constants");
var enums_1 = require("../../Common/utils/enums");
var isMobile_1 = require("../../Common/utils/isMobile");
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var GetHelp = function (_a) {
    var isInline = _a.isInline, isLink = _a.isLink;
    var _b = React.useContext(App_1.RiskContext), state = _b.state, riskClientAppName = _b.riskClientAppName;
    // tslint:disable: strict-boolean-expressions
    var href = constants_1.HelpLinksMap[riskClientAppName] ||
        // fallback to Default in case the riskClientAppName is not in HelpLinksMap
        constants_1.HelpLinksMap[enums_1.RiskClientAppName.Default];
    return (React.createElement(component_button_1["default"], { tag: "a", target: isMobile_1.isMobile() ? undefined : '_blank', href: href, isInline: isInline, onClick: function () {
            VerifyAccountTracking_1.trackContactSupport(state.workflow);
        }, size: isLink ? component_button_1["default"].Sizes.Small : component_button_1["default"].Sizes.Medium, type: isLink ? component_button_1["default"].Types.Link : undefined }, TwoFactorAuthenticationStrings_1["default"].getHelp()));
};
exports["default"] = GetHelp;
